export default __webpack_public_path__ + "static/media/jessica-couch.ee073168.jfif";